"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.967 9.065a.7.7 0 0 1 .99 0L10 10.11l1.044-1.044a.7.7 0 1 1 .99.99L10.99 11.1l1.044 1.044a.7.7 0 0 1-.99.99L10 12.09l-1.044 1.044a.7.7 0 0 1-.99-.99L9.01 11.1l-1.044-1.044a.7.7 0 0 1 0-.99",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.16 7.073C5.687 5.043 7.774 3.63 10 3.63c2.451 0 4.331 1.553 4.666 3.425.809.213 1.555.734 2.123 1.397.715.833 1.211 1.96 1.211 3.183 0 2.608-1.98 4.735-4.667 4.735H6.238C3.814 16.37 2 14.16 2 11.635c0-2.143 1.297-4.02 3.16-4.562M10 5.03c-1.849 0-3.361 1.263-3.546 2.714a.7.7 0 0 1-.587.603C4.538 8.554 3.4 9.879 3.4 11.635c0 1.93 1.354 3.335 2.838 3.335h7.095c1.875 0 3.267-1.46 3.267-3.335 0-.845-.347-1.657-.874-2.272-.534-.623-1.191-.974-1.75-1.01a.7.7 0 0 1-.656-.698c0-1.2-1.219-2.625-3.32-2.625",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StatusIssueServiceDownIcon20.js.map